import type { RatioGroupKey } from "@/config/contentProgramUpload";
import { MediaFrame, TileFoot, TileStatus } from "@/components/content-programs/media-tile";
import type { ContentSubmissionRow } from "@/services/contentProgram.service";
import { affiliateDisplayName, submissionStatus } from "./submission-status";

interface SubmissionPortraitTileProps {
  row: ContentSubmissionRow;
  ratio: RatioGroupKey;
  onOpen: (row: ContentSubmissionRow) => void;
}

/** One submission on the review sheet. Opening it starts the review. */
export function SubmissionPortraitTile({ row, ratio, onOpen }: SubmissionPortraitTileProps) {
  const poster = row.thumbnailUrl || (row.mediaType === "IMAGE" ? row.mediaUrl : null);
  const title = row.title?.trim() || "Untitled";
  const status = submissionStatus(row.status);

  return (
    <button
      type="button"
      onClick={() => onOpen(row)}
      aria-label={`Review ${title}`}
      className="group block w-full rounded-md text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-card"
    >
      <MediaFrame ratio={ratio} poster={poster} isVideo={row.mediaType === "VIDEO"} className="group-hover:ring-foreground/30">
        <TileStatus tone={status.tone} label={status.label} />
        <TileFoot title={title} note={affiliateDisplayName(row)} />
      </MediaFrame>
    </button>
  );
}
